import React, { useEffect, useState } from 'react';

import { Input, Label } from 'reactstrap';

export default function NameDisplay({ attributes, rowId, colId, setValue }) {
  // Inicializa com attributes.value pra suportar pré-preenchimento
  // (ex: paxid identificado no PublicTemplate carrega o nome do attendee).
  const [value, setValue2] = useState(attributes.value || '');

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = value;
      if (attributes.required && !value) {
        newValue[rowId].cols[colId].attributes.errorMessage = `O campo ${attributes.label} é obrigatório`;
      } else {
        newValue[rowId].cols[colId].attributes.errorMessage = '';
      }
      return newValue;
    });
  }, [value, setValue, rowId, colId, attributes]);

  return (
    <div>
      <div className="custom-input-container">
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              <Label htmlFor={`name-${rowId}-${colId}`} className="form-label">
                {attributes.label}
                {attributes.required && '*'}
              </Label>
            </div>
          </div>
          <Input
            className="form-control"
            type="text"
            id={`name-${rowId}-${colId}`}
            placeholder={attributes.placeholder}
            value={value}
            readOnly={!!attributes.readOnly}
            disabled={!!attributes.disabled}
            onChange={({ target }) => setValue2(target.value)}
          />
        </div>
      </div>
    </div>
  );
}
